import { ActionLink } from '@cian/ui-kit';
import { FC } from 'react';

import styles from './ClearTagsAdornment.css';

interface IClearTagsAdornmentProps {
  onAllTagsDeleted: VoidFunction;
  tagsNumber: number;
}

export const ClearTagsAdornment: FC<IClearTagsAdornmentProps> = props => {
  const { tagsNumber, onAllTagsDeleted } = props;

  if (tagsNumber < 2) {
    return null;
  }

  return (
    <div className={styles['clear_tags_button']}>
      {/* fontSize="S" — те же 14px/20px, что были у Button size="XS"; цвет — дефолтный default */}
      <ActionLink fontSize="S" onClick={onAllTagsDeleted}>
        Очистить
      </ActionLink>
    </div>
  );
};
